
// src/web/components/rich-text-editor-template-selection-dialog.js

import React from 'react'
import PureComponent from '../../helpers/pure-component'
import ReactDOM from 'react-dom'
import _ from 'lodash'
import { translate } from 'react-i18next'
import {
  Dialog,
} from 'react-toolbox/lib/dialog'
import {
  List,
  ListItem,
  ListDivider,
} from 'react-toolbox/lib/list'
import ScrollableDialogPanel from './scrollable-dialog-panel.jsx'
import {
  Button,
} from 'react-toolbox/lib/button'
import moment from 'moment'
import shallowEqual from '../../helpers/shallow-equal'

const TIMESTAMP_SINCE_ONE_MONTH = moment().subtract(1, 'months').unix()
const TIMESTAMP_SINCE_TEN_DAYS = moment().subtract(10, 'days').unix()
const DEFAULT_DISPLAY_COUNT = 1
@translate()
class TemplateSelectionDialog extends PureComponent {
  state = { showOldTemplates: false, recentTemplates: undefined, oldTemplates: undefined }

  toggleShowOldTemplates = ()=> this.setState({ showOldTemplates: !this.state.showOldTemplates })
  
  updateTemplatesList = () => {
    //  テンプレートの表示・非表示の条件
    // ・1ヶ月以内に使ったテンプレート→使った順に上から表示する（個数制限なし）
    // ・どのテンプレートも1度も使用したことがない場合(テンプレートが全て表示される)
    // ・過去に使用したことはあるが、1ヶ月以内に使ったテンプレートがない(最新のテンプレート１つが表示され、その他は全て非表示)
    if(this.props.templates){
      let recentTemplates= [], oldTemplates = []
      let notFirstTimeList = _.find(this.props.templates, (item)=> { return item.used_at != 0 })
      let isFirstTime = !notFirstTimeList
      this.props.templates && this.props.templates.map((item, index) => {
        if(index < DEFAULT_DISPLAY_COUNT || item.used_at > TIMESTAMP_SINCE_ONE_MONTH || moment(item.created_at).unix() > TIMESTAMP_SINCE_TEN_DAYS || isFirstTime) recentTemplates.push(item)
        else oldTemplates.push(item)
      })
      this.setState({ recentTemplates, oldTemplates })
    }
  }

  componentDidMount(){
    this.updateTemplatesList()
  }

  componentDidUpdate(prevProps) {
    if (this.props.templates !== prevProps.templates) {
      this.updateTemplatesList()
    }
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (!shallowEqual(this.props.templates, nextProps.templates))
      return true
    return super.shouldComponentUpdate(nextProps, nextState, nextContext)
  }

  onClose = () => {
    this.props.onClose()
    this.setState({ showOldTemplates: false })
  }

  render() {
    const {
      t,
      active,
      onClose,
      onSelect,
      templates,
      actions,
    } = this.props

    if (!templates) return null
    return (
      <Dialog active={active}
          onEscKeyDown={this.onClose}
          onOverlayClick={this.onClose}
          title={t('label:テンプレートを選択')}
          actions={[{ label: t('label:取り消し'), onClick: this.onClose }]} >
          <ScrollableDialogPanel>
            <List selectable ripple>
            {this.state.recentTemplates && this.state.recentTemplates.map((template)=>
              <ListItem key={template.template_id}
                caption={template.template_id != 'last_diary' && template.name || t('label:昨日の投稿内容')}
                onClick={()=> {
                  onSelect(template.template_id, template.name, template.template, template.attach_json)
                  this.onClose()
                }} />
            )}
            {this.state.showOldTemplates && this.state.oldTemplates.map((template)=>
              <ListItem key={template.template_id}
                caption={template.template_id != 'last_diary' && template.name || t('label:昨日の投稿内容')}
                onClick={()=> {
                  onSelect(template.template_id, template.name, template.template, template.attach_json)
                  this.onClose()
                }} />
            )}
            {this.state.oldTemplates && this.state.oldTemplates.length > 0 && <Button
                primary
                onClick={this.toggleShowOldTemplates}
                icon={this.state.showOldTemplates && 'arrow_drop_up' || 'arrow_drop_down'}
                label={this.state.showOldTemplates && t('label:隠す') || t('label:すべて表示')} />}
            {actions && <ListDivider />}
            {actions && actions.map((action)=> 
              <ListItem key={action.name}
                caption={t(`label:${action.name}`)}
                leftIcon="keyboard_arrow_right"
                onClick={()=> {
                  this.onClose()
                  action.callback && action.callback()
                }} />
            )}
            </List>
          </ScrollableDialogPanel>
      </Dialog>
    )
  }
}

export default TemplateSelectionDialog



// WEBPACK FOOTER //
// ./src/web/components/rich-text-editor-template-selection-dialog.jsx